module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px"
    },
    attrs: {
      "id": "content-wrap"
    }
  }, [_c('h1', [_vm._v("Greetings!!")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showEmailBox) ? _c('div', {
    staticStyle: {
      "width": "320px",
      "background-color": "rgba(54, 127, 169, 0.2)",
      "margin": "0px auto",
      "text-align": "left",
      "font-size": "18px"
    }
  }, [_c('h4', [_vm._v("Now you will get an email includes:")]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("To login click here: "), _c('b', {
    staticStyle: {
      "color": "#367fa9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.$root.goto('Login')
      }
    }
  }, [_vm._v("Login")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Please don't hesitate to "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.$root.goto('Contact')
      }
    }
  }, [_vm._v("contact us")]), _vm._v(" for any further information.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Or ready the following installation guide:  "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.$root.goto('Guide')
      }
    }
  }, [_vm._v("Printer Counters Installation Guide.pdf")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("Thank you for choosing "), _c('b', [_vm._v("Printer Counters")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("Verify your account")]), _vm._v(" "), _c('li', [_vm._v("Two links of downloads")]), _vm._v(" "), _c('li', [_vm._v("Authentication key for printers sites")]), _vm._v(" "), _c('li', [_vm._v("Your dashboard will be filled after the downloads in yours customers site")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5ae84cde!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Thanks.vue
// module id = 710
// module chunks = 0